import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Program', path: '/program' },
  { label: 'Houses', path: '/houses' },
  { label: 'Curriculum', path: '/curriculum' },
  { label: 'Partners', path: '/partners' },
  { label: 'News', path: '/news' },
  { label: 'Donate', path: '/donate' },
  { label: 'Contact', path: '/contact' }
];

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b-2 border-black" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <h1 className="text-2xl font-unbounded font-black tracking-tight">AI HOUSE USA</h1>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className={`font-manrope font-medium hover:text-accent transition-colors ${
                  location.pathname === item.path ? 'text-accent' : 'text-black'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/apply"
              data-testid="nav-apply-button"
              className="bg-black text-white px-6 py-3 font-bold uppercase tracking-wide hover:bg-accent hover:shadow-electric transition-all"
            >
              Apply Now
            </Link>
          </div>

          <button
            data-testid="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t-2 border-black"
            data-testid="mobile-menu"
          >
            <div className="px-4 py-4 space-y-4">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block font-manrope font-medium hover:text-accent transition-colors"
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/apply"
                onClick={() => setMobileMenuOpen(false)}
                className="block bg-black text-white px-6 py-3 font-bold uppercase tracking-wide text-center"
              >
                Apply Now
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
